/* Norvena clone kit — scoped to .mk sections. Keep this file name neutral. */
(function () {
  'use strict';

  var BRAND = '#1B2C4E';          /* competitor primary (deep navy) */

  /* ---------- scroll target: the offer / bundle tiers ---------- */
  function offerEl() {
    return document.getElementById('mk-offer')
      || document.querySelector('.lumin-product-block-qty-break')
      || document.querySelector('[class*="quantity-break"]')
      || document.querySelector('.product-form__submit, .lumin-submit');
  }
  function toOffer(e) {
    var t = offerEl();
    if (!t) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }
  window.mkToOffer = toOffer;

  /* ---------- every CTA inside a cloned section goes to the offer ---------- */
  function wireCtas() {
    document.querySelectorAll('.mk a[href], .mk button:not([data-mk-skip])').forEach(function (el) {
      if (el.dataset.mkWired) return;
      /* never hijack the page's own controls */
      if (el.closest('details, summary, [data-zing-prev], [data-zing-next], .mk-no-wire')) return;
      if (el.hasAttribute('data-zing-prev') || el.hasAttribute('data-zing-next')) return;
      if (el.tagName === 'A') {
        var h = el.getAttribute('href') || '';
        if (h.charAt(0) === '#' && h !== '#') return;        /* real in-page anchor */
        if (/^(mailto:|tel:)/i.test(h)) return;
      }
      el.dataset.mkWired = '1';
      el.addEventListener('click', toOffer);
    });
  }

  /* ---------- sticky CTA: shown whenever the offer is off-screen ---------- */
  function sticky() {
    var bar = document.getElementById('mk-sticky');
    if (!bar) return;
    function tick() {
      var t = offerEl(), show = false;
      if (t) {
        /* owner's choice: hidden at the top, appears only once the visitor has
           scrolled PAST the bundle block - never while it is still below. */
        show = t.getBoundingClientRect().bottom < 0;
      }
      /* never cover the cart drawer or its checkout button */
      if (document.querySelector('cart-drawer.active, .cart-drawer.active, .drawer.active, body.overflow-hidden')) show = false;
      bar.style.visibility = show ? 'visible' : 'hidden';
      bar.style.opacity = show ? '1' : '0';
      bar.style.pointerEvents = show ? 'auto' : 'none';
    }
    tick();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    setInterval(tick, 500);
  }

  /* ---------- brand colour on the buy controls ----------
     the theme paints these from an ID-level !important rule, which outranks any
     stylesheet rule we can add; inline !important is the only thing that wins. */
  function paintButtons() {
    document.querySelectorAll(
      '.product-form__submit, .lumin-submit, .sticky-atc-button,' +
      ' .shopify-payment-button__button, .cart__checkout-button, button[name="checkout"]'
    ).forEach(function (b) {
      b.style.setProperty('background', BRAND, 'important');
      b.style.setProperty('background-image', 'none', 'important');
      b.style.setProperty('border-color', BRAND, 'important');
      b.style.setProperty('color', '#ffffff', 'important');
      b.style.setProperty('--product-accent', BRAND, 'important');
      b.style.setProperty('--product-accent-contrast', '#ffffff', 'important');
      b.querySelectorAll('*').forEach(function (k) {
        k.style.setProperty('color', '#ffffff', 'important');
      });
    });
  }

  /* ---------- anything the clone left at opacity:0 must still be visible ---------- */
  function reveals() {
    document.querySelectorAll('.mk [class*="animate--"], .mk .scroll-trigger, .mk .fade-out').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  function init() {
    paintButtons();
    wireCtas();
    reveals();
    sticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(paintButtons).observe(document.documentElement, { childList: true, subtree: true });
})();
